// components/ScrollIndicator.jsx
import React from 'react';

export default function ScrollIndicator() {
  return (
    <div className="scroll-indicator">
      <div className="mouse">
        <div className="wheel"></div>
      </div>
      <p>Scroll</p>
    </div>
  );
}